import { MousePointerClick } from 'lucide-react';

export function EmptyDetailState() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 rounded-full bg-muted p-4">
        <MousePointerClick className="h-12 w-12 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium text-foreground">
        Select a card to view details
      </h3>
      <p className="mt-2 max-w-xs text-sm text-muted-foreground">
        Click on a card from the results to see pricing by condition, price history, and inventory status
      </p>
    </div>
  );
}
